export const allEventActionsReport = {
	title: "Acciones del Evento",
	description: "Lista de todas las acciones a lo largo del evento.",
	filters: {
		employee: {
			label: "Nombre del operador",
			placeholder: "Ingrese o seleccione el operador",
		},
		transaction: {
			label: "Tipo de transacción",
			placeholder: "Ingrese o seleccione el tipo",
		},
	},
	columns: {
		id: "Id",
		date: "Fecha y hora",
		transactionType: "Tipo de transacción",
		employee: "Operador",
		user: "Cliente",
		paymentMethod: "Método de pago",
		products: {
			title: "Productos",
			name: "Nombre del producto",
			count: "Cantidad",
			value: "Valor",
		},
		value: "Valor",
	},
	filename: "reporte-acciones-del-evento",
	paymentMethodWithCashless: {
		ZigPosCredit: "ZigPos Crédito",
		ZigPosCreditInInstallments: "ZigPos Crédito en Cuotas",
		ZigPosDebit: "ZigPos Débito",
		CreditCard: "Tarjeta de crédito",
		DebitCard: "Tarjeta de débito",
		Cash: "Efectivo",
		App: "App",
		Voucher: "Voucher",
		Anticipated: "Anticipado",
		Pix: "Pix",
		Cashless: "Cashless",
		IntegratedFoodVoucher: "Vale de Alimentación integrado",
		MBWay: "Mbway",
		Bonus: "Bono",
		MinimumConsumption: "Consumo mínimo",
		Ifood: "Ifood",
		DigitalCashless: "Cashless digital",
		Online: "Online",
	},
	openingInfoModal: "Datos de apertura del evento",
	opening: "Apertura",
	by: "Por",
	openingTime: "Horario de Apertura",
	openingBy: "Evento Abierto Por",
};
